"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NcDebug", {
    enumerable: true,
    get: function() {
        return NcDebug;
    }
});
const _debug = require("debug");
let NcDebug = class NcDebug {
    static initLogger() {
        if (!NcDebug.logger) {
            NcDebug.logger = (0, _debug.debug)('nc');
        }
        return NcDebug.logger;
    }
    static log(...args) {
        if (!_debug.debug.enabled('nc')) {
            return;
        }
        const logger = NcDebug.initLogger();
        logger(...args);
    }
};
